import { Component, OnInit, OnDestroy } from '@angular/core';
import { fromEvent, merge, Subject, timer } from 'rxjs';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
// @ts-ignore
import { CommandManager } from '@wondavrspaces/resource';
import {debounce, map, takeUntil, tap} from 'rxjs/operators';
import {Observable} from 'rxjs/Observable';

@Component({
  selector: 'undo-redo',
  templateUrl: './undo-redo.component.html',
  styleUrls: ['./undo-redo.component.scss'],
})
export class UndoRedoComponent implements OnInit, OnDestroy {
  public canUndo: boolean;
  public canRedo: boolean;

  constructor(private _dialog: MatDialog) {
    this._refreshUndoRedo = this._refreshUndoRedo.bind(this);
  }

  ngOnInit(): void {
    CommandManager.subscribeToTopic(CommandManager.EVENTS.UNDO_REDO_AVAILABILITY_MODIFIED, this._refreshUndoRedo);
  }

  ngOnDestroy(): void {
    CommandManager.unsubscribeFromTopic(CommandManager.EVENTS.UNDO_REDO_AVAILABILITY_MODIFIED, this._refreshUndoRedo);
  }

  undo(): void {
    if (CommandManager.canUndo()) {
      CommandManager.undo();
    }
  }

  redo(): void {
    if (CommandManager.canRedo()) {
      CommandManager.redo();
    }
  }

  _refreshUndoRedo(): void {
    this.canUndo = CommandManager.canUndo();
    this.canRedo = CommandManager.canRedo();
  }
}
